<template>
  <div class="wrapper">
    <blockquote
      class="pl-4"
      style="border-left: 4px solid"
      :style="{ 'border-color': primaryColor }"
    >
      <p class="font-weight-medium text-h6">{{ textBlockQuote }}</p>
    </blockquote>
  </div>
</template>

<script>
export default {
  props: {
    content: Object,
    primaryColor: String,
  },
  data() {
    return {
      textBlockQuote: "",
    };
  },
  created() {
    this.textBlockQuote = this.formatText(this.content.dsc_texto);
  },
  methods: {
    formatText(text) {
      return text.replace(/\\/g, "");
    },
  },
};
</script>

<style lang="scss" scoped>
div.wrapper {
  width: 90%;
}
blockquote,
.text {
  color: #333333;
  padding: 8px;
  margin-left: 10px;
}
</style>
